/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { PURCHASE_ORDER_STATUSES_OPTIONS } from 'domain/finance/purchaseOrder/usePurchaseOrderService';

const PurchaseOrderStatusDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={PURCHASE_ORDER_STATUSES_OPTIONS} label="Status" {...props} />;
};

export default PurchaseOrderStatusDropdown;
